(function () {
  'use strict';

  function initFbaPage(root) {
    if (!root || root.dataset.fbaInit === '1') return;
    root.dataset.fbaInit = '1';

    var revealEls = root.querySelectorAll('.fba-reveal');
    if (revealEls.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      revealEls.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    root.querySelectorAll('.product-card-heart').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var active = el.classList.toggle('active');
        el.textContent = active ? '\u2665' : '\u2661';
        el.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  }

  function boot() {
    document.querySelectorAll('.usp-fba[data-fba-page]').forEach(initFbaPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('.usp-fba[data-fba-page]');
    if (root) initFbaPage(root);
  });
})();
